export enum ProviderJoinRequestAction {
  INVITE_PROVIDER = 'INVITE',
  MARK_AS_PENDING = 'MARK_AS_PENDING',
  CLOSE_WITHOUT_INVITING = 'CLOSE_WITHOUT_INVITING',
}

export enum CloseWithoutInvitingReason {
  PROVIDER_WILL_BE_INVITED_WITH_PRACTICE = 'PROVIDER_WILL_BE_INVITED_WITH_PRACTICE',
  PROVIDER_NOT_SUITABLE = 'PROVIDER_NOT_SUITABLE',
}
